import { LoginBody } from '../../../interfaces/core/lmsCore';
import LMSCore from '../../../core/lmsCore';
import { showLoading, hideLoading } from '../../../connected-components/loader/reducer';
import { store } from '../../../redux/store';
import { showToast } from '../../../shared/utils/toast';

/**
 * Validates login credentials and attempts to initialize the LMS.
 * Shows loading indicator during the process and hides it when finished.
 *
 * @param {LoginBody} credentials - The user's login credentials
 * @param {Function} t - Translation function for error messages
 * @returns {Promise<boolean>} - A promise resolving to true if login is successful, false otherwise
 */
export const login = async (credentials: LoginBody, t: (key: string) => string): Promise<boolean> => {
  try {
    // Show loading indicator
    store.dispatch(showLoading());

    // Validate credentials
    if (!credentials.username) {
      throw new Error(t('onboarding.usernameRequired'));
    }

    if (!credentials.password) {
      throw new Error(t('onboarding.passwordRequired'));
    }

    // Attempt to initialize LMS
    const success = await LMSCore.initialize(credentials);
    
    if (!success) {
      if (process.env.REACT_APP_DEBUG) {
        console.error('Initialization failed');
      }
      throw new Error('Login failed');
    }

    return true;
  } catch (error) {
    if (process.env.REACT_APP_DEBUG) {
      console.error('Login error:', error);
    }
    showToast.error('Wrong username or password!');
    return false;
  } finally {
    // Hide loading indicator
    store.dispatch(hideLoading());
  }
};